<template>
  <view class="order-head">
    <view class="container" wx:class="{{!showProbability && 'less-height'}}">
      <view class="info" wx:class="{{!showProbability && 'more-width'}}">
        <view class="title">
          <view class="circle-inner">
            <image src="{{circle}}" mode="aspectFit" class="circle" />
            <image src="{{lightning}}" mode="aspectFit" class="lightning" />
          </view>
          <hl-text color="#222222" text="{{stateText.title}}" />
        </view>
        <view bindtap="scanTip" class="sub-title">
          <hl-text color="#666" hlColor="#FF6400" text="{{stateText.subTitle}}">
            <image
              class="icon"
              mode="aspectFit"
              src="https://ut-static.udache.com/webx/sfc/XNKxsIYqRbUxR384Y6Kfa_clipboard_image_1697628299313.png"
            />
          </hl-text>
        </view>
      </view>
      <probability wx:if="{{showProbability}}" pageFrom="detail-page" probability="{{probabilityType}}" tip="抢票成功率" />
    </view>
    <!-- 公告提示条 -->
    <view class="notice-tip-content" wx:if="{{serviceNoticeList && serviceNoticeList.length}}">
      <notice-tip
        class="notice"
        wx:for="{{serviceNoticeList}}"
        wx:key="index"
        titleText="{{item.title}}"
        noticeTitle="{{item.noticeTitle}}"
        type="order"
        bindclick="showNoticeTipsPop(index)"
      />
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'

  createComponent({
    props: {
      serviceNoticeList: [],
      showProbability: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {
        circle: 'https://ut-static.udache.com/webx/sfc/tLTe0iI7rrw65ukM4ugSt.png',
        lightning: 'https://ut-static.udache.com/webx/sfc/PEim2oI0V9bReQIV8361J.png',
      }
    },
    computed: {
      ...store.mapState({
        baseInfo: 'order.base_info',
        scramble_ticket_info: 'order.scramble_ticket_info'
      }),
      stateText() {
        return {
          title: this.baseInfo.status_name,
          subTitle: this.baseInfo.tip
        }
      },
      probabilityType() {
        const {
          alternative_start_date,
          alternative_seat_code,
          alternative_train_codes
        } = this.scramble_ticket_info
        let totalNum =
          alternative_start_date.length +
            alternative_train_codes.length -
            2 || 0
        if (totalNum < 1) return 'low'
        totalNum += alternative_seat_code.length - 1 || 0
        if (totalNum < 2) return 'low'
        else if (totalNum < 4) return 'middle'
        else return 'high'
      }
    },
    methods: {
      showNoticeTipsPop(index) {
        this.triggerEvent('clickIndex', index)
      },
      scanTip() {
        this.triggerEvent('scantip')
      }
    },
  })
</script>
<style scoped lang="stylus">
  @keyframes turn
    0%
      transform rotate(0deg)
    100%
      transform rotate(360deg)
  .order-head
    font-weight normal
    line-height 1
    .container
      width 100%
      box-sizing border-box
      height 128px
      padding 0 10px 0 22px
      @extend .flex-center
      justify-content space-between
      &.less-height
        height 112px
      .info
        max-width calc(100% - 160px)
        &.more-width
          max-width 100%
          width 100%
      .title
        @extend .flex-center
        font-family PingFangSC-Semibold
        font-size 22px
        .circle-inner
          position relative
          display flex
          width 28px
          height 28px
          margin-right 6px
          .circle
            width 100%
            height 100%
            animation turn 1.2s linear infinite
          .lightning
            width 10px
            height 10px
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
      .sub-title
        font-size 12px
        line-height 14px
        margin-top 10px
        .icon
          width 14px
          height 14px
          margin-left 1px
          display inline-block
          vertical-align middle
    .notice-tip-content
      display flex
      flex-direction column
      margin-top 10px
    .notice
      margin-top 1px
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'hl-text': '@/components/hl-text',
      probability: '@/pages/make-order/components/probability',
      'notice-tip': '@/material/block/notice/noticeTip'
    }
  }
</script>